export default function isInViewport(el, options = {}) {
    let headerHeight = document.querySelector('.header__inner')
        ? document.querySelector('.header__inner').getBoundingClientRect().height
        : 0;
    const switchLanguageNotice = document.querySelector('.switch-language-notice');
    let switchLanguageNoticeHeight = (document.body.classList.contains('body--switch-language-notice-is-visible') && switchLanguageNotice)
        ? switchLanguageNotice.getBoundingClientRect().height
        : 0;
    let rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const topOffset = headerHeight + switchLanguageNoticeHeight;

    const triggerLineFromTop = typeof options.triggerLineFromTop === 'number'
        ? options.triggerLineFromTop
        : options.screenRatio;

    if (typeof triggerLineFromTop === 'number') {
        const ratio = Math.max(0, Math.min(1, triggerLineFromTop));
        const triggerLine = topOffset + (viewportHeight - topOffset) * ratio;
        return rect.top <= triggerLine && rect.bottom >= triggerLine;
    }

    return (
        rect.top + rect.height / 2 >= topOffset &&
        rect.bottom - rect.height / 2 <= viewportHeight
    );
}
